// extracted by mini-css-extract-plugin
module.exports = {"column":"_3QxraQseowZFBzhS9L9BK-"};